import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
// import { setInputError } from '../inputError/inputErrorSlice'
import { setMessage } from "../message/messageSlice";

const endPoint = process.env.REACT_APP_API_URL;

export const getUserNotifications = createAsyncThunk(
  "notification/getUserNotifications",
  async ({ user }, thunkApi) => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };
      const res = await axios.get(
        `${endPoint}/notifications/?user=${user.id}`,
        config
      );
      return res;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkApi.dispatch(setMessage(message));
      //   thunkApi.dispatch(setInputError(error.response && error.response.data));
      return thunkApi.rejectWithValue(await error.json());
    }
  }
);

export const markNotificationAsRead = createAsyncThunk(
  "notification/markNotificationAsRead",
  async ({ id }, thunkApi) => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };
      const res = await axios.patch(
        `${endPoint}/notifications/${id}/`,
        {
          is_read: true,
        },
        config
      );
      return await axios.get(
        `${endPoint}/notifications/?user=${res.user.id}`,
        config
      );
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkApi.dispatch(setMessage(message));
      //   thunkApi.dispatch(setInputError(error.response && error.response.data));
      return thunkApi.rejectWithValue(await error.json());
    }
  }
);

export const notificationMarkAllAsRead = createAsyncThunk(
  "notification/notificationMarkAllAsRead",
  async ({ empty }, thunkApi) => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };
      return await axios.post(
        `${endPoint}/notification_mark_all_as_read/`,
        {},
        config
      );
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkApi.dispatch(setMessage(message));
      //   thunkApi.dispatch(setInputError(error.response && error.response.data));
      return thunkApi.rejectWithValue(await error.json());
    }
  }
);

export const notificationDeleteAll = createAsyncThunk(
  "notification/notificationDeleteAll",
  async ({ empty }, thunkApi) => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };
      return await axios.post(
        `${endPoint}/notification_delete_all/`,
        {},
        config
      );
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkApi.dispatch(setMessage(message));
      //   thunkApi.dispatch(setInputError(error.response && error.response.data));
      return thunkApi.rejectWithValue(await error.json());
    }
  }
);
